import { FiDownload, FiX } from 'react-icons/fi';
import { BsCheckCircleFill, BsFileEarmarkZip, BsDiagram3 } from 'react-icons/bs';

export function DownloadModal({ message, downloadUrl, onClose }: { message: string; downloadUrl: string; onClose: () => void }) {
  // Função para iniciar o download ao clicar no botão
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = downloadUrl.substring(downloadUrl.lastIndexOf("/") + 1);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div
      className="modal fade show"
      style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header bg-light">
            <h5 className="modal-title d-flex align-items-center">
              <BsDiagram3 className="me-2" size={20} />
              Diagrama Gerado
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Fechar"
            ></button>
          </div>
          <div className="modal-body p-4">
            <div className="alert alert-success mb-3 d-flex align-items-center">
              <BsCheckCircleFill className="me-2" size={18} />
              <span>{message}</span>
            </div>
            <div className="text-center my-4">
              <BsFileEarmarkZip className="text-primary" style={{ fontSize: "4rem" }} />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary d-flex align-items-center"
              onClick={handleDownload}
            >
              <FiDownload className="me-2" size={18} />
              <span>Baixar ZIP</span>
            </button>
            <button
              type="button"
              className="btn btn-outline-secondary d-flex align-items-center"
              onClick={onClose}
            >
              <FiX className="me-2" size={18} />
              <span>Fechar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
